<div class="min-h-screen flex surface-ground">
  <app-admin-layout-menu></app-admin-layout-menu>
  <div></div>
  <div class="flex flex-column relative flex-auto w-full min-h-screen min-w-0">
      <div #adminMobileHeader class="mobile-header flex-column justify-content-between align-items-center pt-3 pb-2 opacity-90 border-bottom-1 surface-border surface-section sticky z-5">

        <div class="w-full flex flex-wrap justify-content-between align-items-center px-1">
          <button
            pButton
            icon="pi pi-bars text-xl"
            pStyleClass="#app-admin-menu" enterClass="hidden" enterActiveClass="fadeinleft" leaveToClass="hidden" leaveActiveClass="fadeoutleft" [hideOnOutsideClick]="true"
            class="p-button-sm p-button-text p-button-plain p-button-rounded">
          </button>
  
          <span class="flex column-gap-2 align-items-center">

            <div id="{{MOBILE_HEADER_PORTAL_RIGHT_CONTENT_CONTAINER_ID}}"></div>

            @if (pageHeaderService.actionsExists$ | async) {
              <button
                (click)="onOpenModal(pageActions)"
                pButton
                icon="pi pi-ellipsis-v text-xl"
                class="p-button-sm p-button-text p-button-plain p-button-rounded">
              </button>
            }
          </span>
        </div>
        

        <!-- mobile header content-->
        <div id="{{MOBILE_HEADER_PORTAL_UNDER_CONTENT_CONTAINER_ID}}" class="w-full"></div>
      </div>

      <div  class="content-wrap">
        
        <div
          
          class="outlet-wrap primary-outlet-wrap"
          [class.outlet-wrap--compact]="adminLayoutService.showSecondaryContent$ | async"
          [class.outlet-wrap--hidden]="!(adminLayoutService.showPrimaryContent$ | async)">

          <div class="outlet">
            <router-outlet></router-outlet>
          </div>
        </div>

        <div class="relative">
          <div
            container="body"
            [ngbTooltip]="(adminLayoutService.showSecondaryContent$ | async) ? ('admin.event.back-to-event-btn.label' | translate) : null"
            *ngIf="(adminLayoutService.secondaryContentAttached$ | async) && (adminLayoutService.showPrimaryContent$ | async)"
            (click)="adminLayoutService.toggleShowSecondaryContent()"
            [attr.data-test]="'admin-layout-toggle-secondary-content-btn'"
            class="absolute z-4 flex p-2 align-self-start align-items-center surface-ground hover:surface-50 font-medium border-circle cursor-pointer transition-colors transition-duration-150"
            style="top: 1.25rem; {{ (adminLayoutService.showSecondaryContent$ | async) ? 'left: 50%; transform: translateX(-50%);' : 'left:-2.2rem;' }}">
            <i class="pi {{ (adminLayoutService.showSecondaryContent$ | async) ? 'pi-arrow-right' : 'pi-arrow-left' }}  text-color-secondary"></i>
          </div>
        </div>
  
        <div class="outlet-wrap secondary-outlet-wrap"
          [class.outlet-wrap--hidden]="!(adminLayoutService.showSecondaryContent$ | async)">
          <div class="outlet">
            <div *cdkPortalOutlet>

            </div>
          </div>
        </div>


      </div>

  </div>
</div>




<ng-template #pageActions let-modal>
  <div id="{{ HEADER_PORTAL_CONTAINER_ID }}" class="modal-body flex flex-column row-gap-2">

  </div>
</ng-template>
